import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import { connect } from 'react-redux'
import { getProductions, selectProduction } from '../actions/ProductionActions'

const mapStateToProps = state => ({
  authenticated: state.auth.session.token !== false,
  productions: state.production.productions
})

const mapDispatchToProps = dispatch => ({
  getProductionsAction: () => dispatch(getProductions()),
  selectProductionAction: (id) => dispatch(selectProduction(id))
})

class ProductionsComponent extends React.Component {
  componentDidMount() {
    if (this.props.authenticated) {
      this.props.getProductionsAction()
    }
  }

  isUrgent = (item) => item.priority === '2' || item.priority === '3'

  renderTile = (item) => {
    const { selectProductionAction } = this.props
    return (
      <div
        key={item.id}
        className={'elem-tile'
          + (this.isUrgent(item) ? ' important' : '')
          + (item.has_active_operation ? ' elem-tile--current' : '')}
        onClick={() => selectProductionAction(item.id)}
      >
        {item.has_active_operation && <span className="ribbon">W trakcie</span>}
        <div className="elem-tile__top">
          <h5>{item.name}</h5>
          {this.isUrgent(item) && <span className="pill grey">Pilne</span>}
        </div>
        <div className={'elem-tile__start' + (item.is_late ? ' elem-tile__start--late' : '')}>
          {item.is_late && '⚠ '}Planowany start: {item.date_planned_start_display}
        </div>
        <div className="row"><span>Produkt</span><b>{item.product_name}</b></div>
        <div className="row"><span>Zaplanowano</span><b>{item.product_qty} szt.</b></div>
        <div className="row">
          <span>Operacje</span>
          <b>{item.operation_done_count} / {item.operation_count}</b>
        </div>
        <div className="mini-progress">
          <i style={{
            width: `${Math.min(100,
              (item.operation_done_count / (item.operation_count || 1)) * 100)}%`
          }} />
        </div>
        <div className="elem-footer">
          Na tym stanowisku: {item.my_operation_count}
        </div>
        <div className="elem-tile__meta">
          Data utworzenia: {item.create_date_display}
          {item.responsible_name && <> · Zlecający: {item.responsible_name}</>}
        </div>
      </div>
    )
  }

  render() {
    const { authenticated, productions } = this.props
    if (!authenticated) return <Redirect to='/login' />

    const items = productions || []
    const current = items.filter(item => item.has_active_operation)
    const pending = items.filter(item => !item.has_active_operation)

    return (
      <>
        <h2>Zlecenia produkcyjne</h2>
        {current.length > 0 && (
          <>
            <h3 className="section-title">Bieżące zlecenie produkcyjne</h3>
            <div className="elem-list">
              {current.map(this.renderTile)}
            </div>
            <hr className="section-divider" />
          </>
        )}
        <h3 className="section-title">Oczekujące zlecenia produkcyjne</h3>
        <div className="elem-list">
          {pending.map(this.renderTile)}
          {!items.length &&
            <p>Brak zleceń produkcyjnych dla tego stanowiska.</p>}
        </div>
      </>
    )
  }
}

const Productions = connect(mapStateToProps, mapDispatchToProps)(ProductionsComponent)
export default withRouter(Productions)
